// Image imports
import hershPortrait from '../../../images/hersh_portrait.jpg';
import hershFriends from '../../../images/hersh_friends.jpg';
import hershSisters from '../../../images/hersh_sisters.jpg';

export const hershGoldbergpolinMemorial = {
  id: 3,
  name: 'Hersh Goldberg-Polin',
  category: 'young-lives',
  images: {
    portrait: hershPortrait,
    friends: hershFriends,
    sisters: hershSisters
  },
  info: `

# Hersh Goldberg-Polin

"You charmed everyone you ever talked to, old or young. You promoted justice and peace in a way only a young pure, wide-eyed idealist, can." - Rachel Goldberg-Polin

![Hersh Goldberg-Polin portrait](${hershPortrait})
*Hersh Goldberg-Polin, a beacon of light and love*

## A Life of Purpose

Hersh was a young man who lived his life with purpose and compassion. He was known for his inquisitive nature, always seeking to understand different perspectives on complex issues. His father, Jon Polin, described him as "a true poel yeshuot" - a worker for salvation, someone who constantly sought ways to make the world better.

![Hersh with friends](${hershFriends})
*Hersh supported peace and coexisence*

## Activism and Idealism

Hersh's commitment to social justice was evident in his actions. He moved his family towards activism for the rights of African migrants and other causes. His idealism was not just talk - he lived it every day, challenging those around him to think beyond themselves.

> "You would ignore people's public posturing and what people say at press conferences, and you would push every decision maker to truly look themselves in the mirror and to ask themselves selflessly every single day, 'Will the decisions I made today lead to a better future for all of us?'" - Jon Polin

## A Beloved Brother

Hersh's sisters, Leebie and Orly, spoke of the deep connection they shared. Leebie described it as "a string tying the siblings together" that stretched beyond the limits of earth and sky. Orly admired her big brother, learning from him how to fight for what's important and to respect their parents.

![Hersh with sisters](${hershSisters})
*Hersh with his sisters Leebie and Orly, sharing an unbreakable bond*

## Passion for Sports and Travel

Hersh was an avid supporter of HaPoel Jerusalem, his local team. His love for sports was matched by his passion for travel. He dreamed of exploring the world, always curious about different cultures and experiences.

## A Tragic End

Hersh was taken hostage by Hamas on October 7, 2023, while attending the Nova music festival. For 330 days, his family tirelessly advocated for his release and that of all the hostages. Tragically, Hersh was among six hostages whose bodies were recovered in Gaza.

## Remembering Hersh

At his funeral in Jerusalem, President Herzog spoke of how Hersh touched all of humanity deeply. His father called for his memory to be "a revolution," hoping that his death could be the catalyst to bring home the remaining hostages.

Rachel Goldberg-Polin, in a heartbreaking farewell to her son, said:

> "OK sweet boy, go now on your journey. I hope it's as good as the trips you've dreamed about because finally, finally, finally, finally you are free."

Hersh Goldberg-Polin's life, though cut short, was filled with love, purpose, and a genuine desire to make the world a better place. May his memory indeed be a revolution, inspiring others to work towards peace and understanding.

*We will always remember you, Hersh.*

[Read more about Hersh](https://www.kveller.com/at-hersh-goldberg-polins-funeral-a-beautiful-boy-remembered/)


`
};